import { store } from "@/store/store";
import * as Sentry from "@sentry/nextjs";
import router from "next/router";
import { INVALID_TOKEN_ERROR } from "../consts/errors";
import { performClientSideLogout } from "../features/auth/utils/auth.utils";

interface GraphqlError {
  message: string;
  path: string[];
  extensions: any;
  location: any;
}

export const handleGraphqlErrors = (errors: GraphqlError[]) => {
  for (const error of errors) {
    let { message: errorMessage } = error;

    Sentry.addBreadcrumb({
      message: errorMessage,
      level: "error",
      data: error,
    });

    Sentry.addBreadcrumb({
      message: "data",
      level: "error",
      data: error?.extensions?.exception?.data?.message,
    });
    Sentry.captureException(new Error(errorMessage), {});

    switch (error.message) {
      case INVALID_TOKEN_ERROR:
        performClientSideLogout(store.dispatch);
        errorMessage = "Authorization token has expired";
        router.push("/auth/login");
        break;
    }

    if (errorMessage !== "Forbidden") {
      // message.error(errorMessage);
    }

    throw new Error(errorMessage);
  }
};
